'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _message2 = require('antd/lib/message');

var _message3 = _interopRequireDefault(_message2);

var _upload = require('antd/lib/upload');

var _upload2 = _interopRequireDefault(_upload);

require('antd/lib/icon/style');

require('antd/lib/message/style');

require('antd/lib/upload/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultiUpload = _upload2.default.Dragger;

var beforeUpload = function beforeUpload(file) {
  var isLt10M = file.size / 1024 / 1024 < 10;
  if (!isLt10M) {
    _message3.default.error('Зурагны хэмжээ 10MB ээс бага байх ёстой');
  }
  return isLt10M;
};

var DraggerWidget = function DraggerWidget(props) {
  var handleChange = function handleChange(info) {
    if (info.file.status === 'done') {
      console.log('Uploads Info : ', info);
      props.onChange(info.file.response.data);
    }
  };

  return _react2.default.createElement(
    MultiUpload,
    {
      className: 'avatar-uploader ' + _style2.default.avatarUploader,
      accept: 'image/*',
      name: 'image',
      showUploadList: false,
      action: '/rest/store_product/upload_image',
      beforeUpload: beforeUpload,
      onChange: handleChange
    },
    props.value ? _react2.default.createElement('div', { style: { backgroundImage: 'url(' + props.value + ')' }, className: 'avatar ' + _style2.default.avatar }) : _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_icon2.default, { type: 'plus', className: 'avatar-uploader-trigger ' + _style2.default.avatarUploaderTrigger }),
      _react2.default.createElement(
        'p',
        { className: 'ant-upload-hint' },
        '\u0417\u0443\u0440\u0430\u0433 \u043D\u044D\u043C\u044D\u0445'
      )
    )
  );
};

DraggerWidget.defaultProps = {
  value: ''
};

DraggerWidget.propTypes = {
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired
};

exports.default = DraggerWidget;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Form/Widgets/DraggerWidget/index.js
// module id = 904
// module chunks = 0